import { UserProfile } from '@/models/user-profile';
import firebase from 'firebase/app';
import * as fb from '@/firebase';
import { UserModule } from '@/store/modules/user';

export class UserProfileUtil {
  public static async hydrateUsers(userIds: string[]): Promise<UserProfile[]> {
    const docPromises = userIds.map((id: string) =>
      fb.usersCollection.doc(id).get()
    );
    const docs = await Promise.all(docPromises);
    return docs
      .filter((userDoc) => !!userDoc.data())
      .map((userDoc) =>
        UserProfile.fromFirebaseDoc(userDoc.id, userDoc.data())
      );
  }

  // TODO: is there anything else to delete that this user owns?
  public static deleteAccount() {
    fb.usersCollection.doc(UserModule.userProfile.id).delete();
    fb.listsCollection
      .where('authorId', '==', UserModule.userProfile.id)
      .get()
      .then((querySnapshot: firebase.firestore.QuerySnapshot) => {
        querySnapshot.forEach(
          (doc: firebase.firestore.QueryDocumentSnapshot) => {
            doc.ref.delete();
          }
        );
      });
  }

  public static updateNumLists(userId: string, delta: number): Promise<any> {
    return fb.usersCollection
      .doc(UserModule.userProfile.id)
      .update('numPublicLists', firebase.firestore.FieldValue.increment(delta));
  }

  public static userUpdateTransaction(
    userId: string,
    updateCallback: (a: UserProfile) => any
  ): Promise<any> {
    const userDocRef = fb.usersCollection.doc(userId);
    return fb.firestore.runTransaction((transaction) => {
      // This code may get re-run multiple times if there are conflicts.
      return transaction.get(userDocRef).then((userDoc) => {
        if (!userDoc.exists) {
          throw new Error('Document does not exist!');
        }
        const userProfile = UserProfile.fromFirebaseDoc(
          userDoc.id,
          userDoc.data()
        );
        const updateData = updateCallback(userProfile);
        
        transaction.update(userDocRef, updateData);
      });
    });
  }

  public static fetchProfileByUsername(username: string): Promise<UserProfile> {
    return fb.usersCollection
      .where('username', '==', username)
      .get()
      .then((querySnapshot: firebase.firestore.QuerySnapshot) => {
        if (querySnapshot.docs && querySnapshot.docs.length > 0) {
          const doc = querySnapshot.docs[0];
          return UserProfile.fromFirebaseDoc(doc.id, doc.data());
        } else {
          throw new Error('user profile not there');
        }
      });
  }

  public static fetchProfileById(uid: string): Promise<UserProfile> {
    return fb.usersCollection.doc(uid)
      .get()
      .then((doc: firebase.firestore.DocumentSnapshot) => {
        if (doc) {
          return UserProfile.fromFirebaseDoc(doc.id, doc.data());
        } else {
          throw new Error('user profile not there');
        }
      });
  }

  public static fetchMostFollowedProfiles(limit: number = 10): Promise<UserProfile[]> {
    return fb.usersCollection
      .orderBy('numFollowers', 'desc')
      .limit(limit)
      .get()
      .then((querySnapshot: firebase.firestore.QuerySnapshot) => {
        return querySnapshot.docs.map((doc) =>
          UserProfile.fromFirebaseDoc(doc.id, doc.data())
        );
      });
  }

  public static setIsAdmin(userId: string, isAdmin: Boolean): Promise<any> {
    console.log('setIsAdmin');
    return fb.usersCollection.doc(userId).update({isAdmin});
  }
}
